/* eslint-disable max-lines */
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MyQuotesService } from '../my-quotes.service';
import { EquipmentQuoteHeader, MyQuotesState, StatusPayload } from '../definitions';
import { BehaviorSubject, Subscription, debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs';
import { SharedService } from '../../../services/shared/shared.service';
import { Control, ControlType, Cta, CtaClickEvent, DateRange, KngCardListState, KngFilterPanelComponent, KngFilterState, KngHeaderObjState, KngSelectionData, Section, Option } from 'kinetic-angular';
import { Address, KeyValuePair, LocationAddress } from '../../../services/shared/shared-interface';
import { FilterOptions, Icons, SortOrder, DownloadNote } from '../../../services/shared/shared-enums';
import { SharedFilterService } from '../../../services/shared/shared-filter.service';
import { DateConverterService } from '../../../services/date-converter/date-converter.service';
import { MyQuotesFactory } from '../my-quotes.factory';
import { defaultPage } from '../../../services/shared/shared-constants';
import { SharedUtilService } from '../../../services/shared/shared-util.service';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { RedirectRoute } from 'projects/kinetic-angular/src/lib/shared/shared.interface';
import { MyQuotesUtilService } from '../my-quotes.util.service';

@Component({
	selector: 'tmhna-portal-equipment-quotes',
	templateUrl: './equipment-quotes.component.html',
	styleUrls: ['./equipment-quotes.component.scss']
})
export class EquipmentQuotesComponent implements OnInit, AfterViewInit
{
	cardState!: KngCardListState;
	private readonly searchText$ = new BehaviorSubject<string>('');
	searched: boolean = false;
	currentPage = 0;
	resetPage: number = 0;
	originalDataLoaded: boolean = false;
	paginated:boolean=false;
	@ViewChild(KngFilterPanelComponent, { static: true }) myQuotesFilterComponent: | KngFilterPanelComponent | undefined;
	selectedFilterObj: KeyValuePair[] = [{ key: FilterOptions.dateRange, value: DateRange.lastSixtyDays, id: '',	disabled: true }];
	defaultFilter: boolean = true;
	toDate: number = 0;
	fromDate: number = 0;
	selectedStatusFilter: string = '';
	addressSelected: LocationAddress[] = [];
	private readonly subscriptions$: Subscription = new Subscription();
	billingAddressKey = FilterOptions.billingAddress;
	appliedAddressIds: string[] = [];
	icons = Icons;
	downloadNote = DownloadNote;
	isRaymond: boolean = false;
	constructor(public service: MyQuotesService, public sharedService: SharedService, public filterService: SharedFilterService, public dateService: DateConverterService, public sharedUtilService: SharedUtilService,
		public analyticsService:AnalyticsService, private readonly myQuotesUtilService: MyQuotesUtilService) { }

	@Input() set state(value: MyQuotesState) 
	{
		this.service.updateState(value);
	}
	get state(): MyQuotesState 
	{
		return this.service.state;
	}
	get isInvalidLength() 
	{
		return this.sharedService.isInvalidLength(this.service.searchData);
	}
	get filterState(): KngFilterState 
	{
		return this.state.sectionMiddle.filteringPanelSection.filterState;
	}
	ngOnInit(): void 
	{
		this.isRaymond = this.service.isRaymond;
		this.service.initializePayload();
		this.filterState.hidden = true;
		this.service.searchData='';
		this.service.sortingEvent = this.sharedUtilService.getHeaderObjectState(true, EquipmentQuoteHeader.creationDate, SortOrder.desc);
		this.service.myQuotesPayload.sort = this.sharedService.checkTableSort(this.service.sortingEvent, EquipmentQuoteHeader);
		this.initializeStructure(0);
	}
	ngAfterViewInit(): void
	{
		if (this.myQuotesFilterComponent)
			this.getBillingAddress();
		this.subscribeSearchText();
	}
	public initializeStructure(page: number): void
	{
		this.originalDataLoaded = true;
		this.service.myQuotesTableStateObject.next(MyQuotesFactory.buildMyQuotetList());
		this.sharedUtilService.checkCardState(this.cardState);
		this.service.getQuotesTable(page);
		this.myQuotesUtilService.getBillingAddress();
	}
	applySearch()
	{
		this.sharedUtilService.checkCardState(this.cardState);
		this.searchText$.next(this.service.searchData.trimLeft());
		this.searched= true;
	}
	getOriginalData() 
	{
		this.resetPage--;
		this.searchText$.next('');
		this.service.searchData = '';
		this.applySearch();
	}
	pageChanged(page: number)
	{
    	this.currentPage = page;
		if(page !== 0)
		{
			this.paginated = true;
			this.initializeStructure(page);
		}
		else if(page === 0 && this.paginated)
			this.initializeStructure(0);
	}
	openFilter() 
	{
		if (this.myQuotesFilterComponent !== undefined)
			this.state.sectionMiddle.filteringPanelSection.filterState.hidden = false;
	}
	closeFilter() 
	{
		this.myQuotesUtilService.updateBillingAddressSection(this.myQuotesUtilService.billingAddressFilterControls, this.appliedAddressIds);
		this.getCountOfFilterPanel(this.filterState.filterData.sections[1]);
		this.filterState.filterData.sections[0] = this.filterService.setDateFilterCloseFilter(this.selectedFilterObj, this.filterState.filterData.sections[0], this.myQuotesFilterComponent);
	}
	filterStateChanged() 
	{
		this.filterState.filterData.ctaList[0].disabled = !this.filterService.filterHasAtLeastOneSelectedControl(this.filterState);
	}
	filterApplied(event: CtaClickEvent) 
	{
		const btnIndex = event.state.filterData.ctaList.findIndex((cta: Cta) => cta.label === event.buttonClicked.label);
		if (btnIndex === 1) 
		{
			this.resetPage++;
			this.selectedFilterObj = [];
			this.updateAddressPayload();
			this.updateDatePayload(event.state.filterData.sections[0].controls);
			this.getTableDataAndUpdateState();
			this.state.sectionMiddle.filteringPanelSection.filterState.hidden = true;
			this.trackAnalyticsOnApplyFilter();
		}
		else
		{
			this.resetPage--;
			this.clearAllFilterPanel();
		}
	}
	clearAllFilterPanel()
	{
		let sections = this.filterState.filterData.sections;
		sections = this.filterService.clearAllFilterPanel(sections);
		sections[0] = this.filterService.setDateFilterLabelCheck(sections[0], DateRange.lastSixtyDays);
		if(this.myQuotesFilterComponent)
			this.myQuotesFilterComponent.setDefaultToFromDate();
		this.service.myQuotesPayload.locations = [];
		this.service.myQuotesPayload.salesProspectAddress = [];
		this.service.initializeDatePayload();
		this.analyticsService.trackByEvent({
			event: 'Filter Cleared',
			link: {
				name: 'Filter Cleared'
			}
		});
	}
	updateDatePayload(controls: Control[]) 
	{
		controls.forEach((control: Control) => 
		{
			if (control.type === ControlType.radio && control.options.length > 0) 
			{
				control.options.forEach((opt) => 
				{
					if (opt.checked && opt.checked === true) 
					{
						this.setDefaultCustomDate(opt);
						this.defaultFilter = false;
						this.selectedFilterObj = this.filterService.addSelectedFilter(opt.label, FilterOptions.dateRange, this.selectedFilterObj, opt.value);
						const fromToDate = this.dateService.dateCalculation(this.filterState.filterData.sections[0].controls[0].options, opt.label);
						this.fromDate = fromToDate[0];
						this.toDate = fromToDate[1];
						if (opt.label === DateRange.lastSixtyDays && this.selectedFilterObj.length === 1)
							this.defaultFilter = true;
					}
				});
			}
		});
		if (this.fromDate !== 0) 
		{
			this.service.myQuotesPayload.endDate = this.toDate;
			this.service.myQuotesPayload.startDate = this.dateService.getUnixTimeStamp(new Date(this.fromDate));
		}
	}
	public getCountOfFilterPanel(section: Section): void
	{
		let control: Control[] = [];
		if (section.label === FilterOptions.billingAddress)
			control = this.myQuotesUtilService.billingAddressFilterControls;
		this.filterState.filterData.sections = this.filterService.getCountOfFilterPanel(control, section.label, this.filterState.filterData.sections, this.myQuotesFilterComponent);
	}
	removeFilter(filter: KeyValuePair): void 
	{
		this.removeFilterForDateRange(filter);
		this.resetFilterPanel(filter);
		this.removeFilterForBillingAddress(filter);
		this.getTableDataAndUpdateState();
	}
	removeFilterForDateRange(filter: KeyValuePair): void
	{
		if (filter.key === FilterOptions.dateRange) 
		{
			this.selectedFilterObj.forEach((obj) => 
			{
				if (obj.key === filter.key) 
				{
					obj.value = DateRange.lastSixtyDays;
					if (this.selectedFilterObj.length === 1)
						this.defaultFilter = true;
					this.filterService.mapSelectedFilter(this.selectedFilterObj);
				}
			});
			this.service.initializeDatePayload();
		}
	}
	removeFilterForBillingAddress(filter: KeyValuePair): void
	{
		if (filter.key === FilterOptions.billingAddress) 
		{
			this.selectedFilterObj.forEach((obj) => 
			{
				if (obj.id === filter.id && filter.id !== undefined)
					this.resetBillingAddressFilter(filter.id, filter.key);
			});
		}
	}
	resetBillingAddressFilter(id: string, key: string): void 
	{
		const salesProspectAddress = this.addressSelected;
		let index = -1;
		if (salesProspectAddress) 
		{
			this.defaultFilter = false;
			this.selectedFilterObj = this.filterService.removeFromSelectedFilter(id, salesProspectAddress, this.selectedFilterObj);
			if (this.selectedFilterObj.length === 1 && this.selectedFilterObj[0].value === DateRange.lastSixtyDays) 
			{
				this.defaultFilter = true;
				this.selectedFilterObj[0].disabled = true;
			}
			index = salesProspectAddress.findIndex(loc => loc.id === id);
			salesProspectAddress.splice(index, 1);
			this.state.sectionMiddle.filteringPanelSection.filterState.filterData.sections = this.filterService.removeSearchtextfromInputAfterClear(salesProspectAddress, key, this.state.sectionMiddle.filteringPanelSection.filterState.filterData.sections);
			this.service.myQuotesPayload.salesProspectAddress = salesProspectAddress;
			this.service.myQuotesPayload.salesProspectAddress.forEach(loc => delete loc.id);	

		}
	}
	resetFilterPanel(filter: KeyValuePair)
	{
		if (filter.key === FilterOptions.dateRange) 
			this.filterState.filterData.sections[0] = this.filterService.setDateFilterLabelCheck(this.filterState.filterData.sections[0], DateRange.lastSixtyDays);
		else if (filter.key === FilterOptions.billingAddress)
			this.resetFilterPanelForBillingAddress(filter);
	}
	resetFilterPanelForBillingAddress(filter: KeyValuePair): void
	{		
		const control = this.myQuotesUtilService.billingAddressFilterControls;
		control.forEach((ctl) => 
		{
			if (ctl.id === filter.id && ctl.id) 
			{
				ctl.setValue(false);
				this.getCountOfFilterPanel(this.filterState.filterData.sections[1]);
			}
		});
		this.myQuotesUtilService.billingAddressFilterControls = control;
	}
	setDefaultCustomDate(opt: Option)
	{
		if(opt.label !== FilterOptions.customDateRange && this.myQuotesFilterComponent)
			this.myQuotesFilterComponent.setDefaultToFromDate();
	}
	removeAllFilter() 
	{
		this.clearAllFilterPanel();
		this.selectedFilterObj = [{ key: FilterOptions.dateRange, value: DateRange.lastSixtyDays, id: '',	disabled: true }];
		this.defaultFilter = true;
		this.getTableDataAndUpdateState();
		this.dateService.showHideFromToDate(this.myQuotesFilterComponent);
	}
	subscribeSearchText()
	{
		this.searchText$
			.pipe(debounceTime(500), filter(searchTerm => (searchTerm.replace(/\s/g, '').trim().length === 0 || searchTerm.replace(/\s/g, '').trim().length > 3)), distinctUntilChanged(),
				switchMap((val) => 
				{
					this.resetPage++;
					this.originalDataLoaded = false;
					this.service.myQuotesTableStateObject.next(MyQuotesFactory.buildMyQuotetList());
					this.service.myQuotesPayload.searchValue = val.trimLeft();
					if (this.searched) 
					{
						this.service.getQuotesTable(defaultPage);
					}
					return this.service.myQuotesTableStateObject;
				})).subscribe((res) => 
			{
				this.cardState = res;
			 });
	}
	checkSortEvent(event: KngHeaderObjState) 
	{
		this.service.sortingEvent = event;
		this.service.myQuotesPayload.sort = this.sharedService.checkTableSort(event, EquipmentQuoteHeader);
		this.service.getQuotesTable(this.currentPage);
	}
	resetPageProperties() 
	{
		this.currentPage = 0;
		this.resetPage--;
	}
	applyStatusFilterToCount(data: KngSelectionData): void
	{
		this.resetPageProperties();
		this.selectedStatusFilter = this.sharedUtilService.getMyQuotesStatus(data.selectedStatus);
		this.service.myQuotesPayload.status = [];
		if (this.selectedStatusFilter === '')
		{
			this.service.myQuotesPayload.status = [ StatusPayload.ordered, StatusPayload.expired, StatusPayload.quoteAccepted, StatusPayload.quoteinProcess, StatusPayload.readyForReview ];
		}
		else 
		{
			this.service.myQuotesPayload.status?.push(this.selectedStatusFilter);
		}
		this.getTableDataAndUpdateState();
	}

	getTableDataAndUpdateState()
	{
		this.service.myQuotesTableStateObject.next(MyQuotesFactory.buildMyQuotetList());
		this.service.getQuotesTable(this.currentPage);
		this.service.myQuotesTableStateObject.subscribe((res) => 
		{
			this.cardState = res;
		});
	}
	getBillingAddress(): void
	{
		const billingAddressFilterControls: Control[] = this.state.sectionMiddle.filteringPanelSection.filterState.filterData.sections[1].controls;
		const billingAddressSearchControl: Control = billingAddressFilterControls[0];
		const billingAddressSearchSubscription: Subscription =
			billingAddressSearchControl.valueChanges
				.pipe(filter((value: string) => value.length > 2 || billingAddressFilterControls.length > 1),
					debounceTime(500),
					distinctUntilChanged(),
					switchMap(async (value: string) => this.myQuotesUtilService.findAssignedBillingAddress(value)))
				.subscribe((result: Control[]) => this.filterService.updateFilterPanelOptions(result, billingAddressFilterControls, this.myQuotesFilterComponent, this.filterState));
		this.subscriptions$.add(billingAddressSearchSubscription);
	}
	updateAddressPayload(): void
	{
		const selectedBillingAddress: LocationAddress[] = [];
		this.addressSelected = [];
		this.myQuotesUtilService.billingAddressFilterControls.forEach((control: Control) => 
		{
			if (control.type === ControlType.checkbox && control.value && control.address) 
			{
				this.defaultFilter = false;
				const updatedBillingAddress: LocationAddress = {
					addressLine1: control.address.addressLine1,
					addressLine2: control.address.addressLine2,
					city: control.address.city,
					state: control.address.state,
					country: control.address.country ?? '',
					postalCode: control.address.zipCode
				};
				this.addressSelected.push({
					...updatedBillingAddress,
					id: control.id });
				selectedBillingAddress.push(updatedBillingAddress);
				const label = this.myQuotesUtilService.formatAddress(control.address as Address);
				this.selectedFilterObj = this.filterService.addSelectedFilter(label, FilterOptions.billingAddress, this.selectedFilterObj, undefined, control.id);
			}
		});
		this.processSelectedAddress(selectedBillingAddress);
	}
	processSelectedAddress(selectedBillingAddress: LocationAddress[]): void
	{
		if (!selectedBillingAddress.length) 		
			this.service.myQuotesPayload.salesProspectAddress = [];
		else 
		{
			this.service.myQuotesPayload.salesProspectAddress = selectedBillingAddress;
		}
	}
	downloadQuotePdf(redirectRoute: RedirectRoute)
	{
		if (redirectRoute?.value || redirectRoute?.documentURL) 
			this.service.getdownloadQuotePdf(redirectRoute.documentURL);
	}
	trackAnalyticsOnApplyFilter()
	{
		this.analyticsService.trackByEvent({
			event: 'MyQuotes Filter Applied',
			link: { name: 'MyQuotes Filter' },
			filter: this.selectedFilterObj.map(item => ({
				label: item.key,
				value: item.value,
				type: 'MyQuotes Table'
			}))
		});
	}
	downloadMyQuotesTableData()
	{
    	this.service.downloadMyQuotesData(0);
	}
}
